module.exports = __webpack_public_path__ + "static/media/video.877781b9.mp4";